import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SnackbarService } from '../error/snackbar.service';
import { SnackbarConfig, SnackbarPosition, SnackbarType } from '../../enums/snackbar-config';
import { DefaultMachinePerformanceListDto } from '../../models/machine-performances/default-machine-performance-list-dto';
import { MachineType } from '../../enums/machine-type';
import { GetProductionTechnicianAreaEnum, ProductionTechnicianArea, ProductionTechnicianAreaLabels } from '../../enums/production-technician-area';
import { MachineSize } from '../../models/machines/machine-size';
import { browserOnly } from './browser-only.util';

@Injectable({
  providedIn: 'root'
})
export class MachinePerformanceApiService {
  private apiUrl = environment.apiBaseUrl;

  constructor(
    private http: HttpClient,
    private snackBarService: SnackbarService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  getDefaultMachinePerformanceList(machineType: MachineType): Observable<DefaultMachinePerformanceListDto[]> {
    return browserOnly<DefaultMachinePerformanceListDto[]>(this.platformId, [], () => this.http.get<DefaultMachinePerformanceListDto[]>(`${this.apiUrl}/defaultmachineperformance/${machineType}`).pipe(catchError(error => this.snackBarService.handleApiError(error))));
  }

  getDefaultMachinePerformanceListByProductionTechnicianArea(productionTechnicianArea: string, machineType: MachineType, machineSize: MachineSize): Observable<DefaultMachinePerformanceListDto[]> {
    const areaEnumValue = GetProductionTechnicianAreaEnum(productionTechnicianArea);

    return browserOnly<DefaultMachinePerformanceListDto[]>(this.platformId, [], () => this.http.get<DefaultMachinePerformanceListDto[]>(`${this.apiUrl}/defaultmachineperformance/by-production-technician-area?productionTechnicianArea=${areaEnumValue}&machineType=${machineType}&machineSize=${machineSize}`).pipe(catchError(error => this.snackBarService.handleApiError(error))));
  }

  addDefaultMachinePerformance(machinePerformance: DefaultMachinePerformanceListDto): Observable<any> {

    console.log('addDefaultMachinePerformance', machinePerformance)

    return browserOnly<never>(this.platformId, {} as never, () => this.http.post<never>(`${this.apiUrl}/defaultmachineperformance`, machinePerformance, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    }).pipe(tap(() => {
      this.snackBarService.showResponse("Standardvärde skapat.", SnackbarConfig.combine(SnackbarType.SUCCESS, SnackbarPosition.BOTTOM))
    }),
      catchError(error => this.snackBarService.handleApiError(error))
    ))
  }

  updateDefaultMachinePerformance(machinePerformance: DefaultMachinePerformanceListDto): Observable<any> {

    return browserOnly<never>(this.platformId, {} as never, () => this.http.put<never>(`${this.apiUrl}/defaultmachineperformance/update/`, machinePerformance, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    }).pipe(tap(() => {
      this.snackBarService.showResponse("Sparning genomförd.", SnackbarConfig.combine(SnackbarType.SUCCESS, SnackbarPosition.BOTTOM))
    }),
      catchError(error => this.snackBarService.handleApiError(error))
    ))
  }

  deleteDefaultMachinePerformance(deleteDefaultMachinePerformanceModel: DefaultMachinePerformanceListDto): Observable<void> {

    return browserOnly<void>(this.platformId, undefined as void, () => this.http.delete<void>(`${this.apiUrl}/defaultmachineperformance/delete/${deleteDefaultMachinePerformanceModel.id}`).pipe(
      tap(() => {
        this.snackBarService.showResponse("Standardvärde borttaget.", SnackbarConfig.combine(SnackbarType.SUCCESS, SnackbarPosition.BOTTOM))
      }),
      catchError(error => this.snackBarService.handleApiError(error))
    ));
  }

}
